<template>
    <div style="display: flex; flex-direction: row; justify-content: center">
        <div align="center" style="line-height: 20px; margin-right: 10px">
            <img style="height:15px" src="../assets/images/arrow-up.png" @click="increaseCounter()"/>
        </div>
        <div class="team-name">
            <span class="home-away">{{ homeAway }}</span><br/>
            <span>{{ teamName }}</span>
        </div>
        <div align="center" style="line-height: 20px; margin-left: 10px">
            <img style="height:15px" src="../assets/images/arrow-down.png" @click="decreaseCounter()"/>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import '../assets/css/score-changer.css';

export default {
    props: ['linkedCounter', 'teamName', 'homeAway'],
    data() {
        return {
        };
    },
    methods: {
        jumpToNumber(number) {
            this.$parent.$refs[this.linkedCounter].jumpToNumber(number);
        },
        increaseCounter() {
            this.$emit('clickUp');
        },
        decreaseCounter() {
            this.$emit('clickDown');
        }
    },   
    created () {
        
    },
    mounted() {

    },
    computed: {
        ...mapGetters({
        })
    }}
</script>


// WEBPACK FOOTER //
// src/components/ScoreChanger.vue